import { api } from ".";

export const builderApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBuilderData: build.query({
      query({ category, catId }) {
        return {
          url: `/config/laminat`,
          method: "GET",
          params: {
            cat: category || "",
            id: catId || "",
          },
        };
      },
    }),
  }),
});

export const { useGetBuilderDataQuery } = builderApi;
